'use client';
import { useEffect } from 'react';
import Image from 'next/image';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

declare global {
  interface Window {
    hbspt: any;
  }
}

export default function ContactPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '43968755',
          formId: '4c845063-2801-47e4-881a-422c3d45bb2e',
          region: 'na1',
          target: '#hubspotForm',
        });
      }
    };
    document.body.appendChild(script);

    // Cleanup script when unmounting (optional)
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div data-component-id="src/app/contact-us/ContactPage.tsx:39:4" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="39" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-secondary-background%20min-h-screen%20flex%20flex-col%22%7D" className="w-full bg-secondary-background min-h-screen flex flex-col">
      {/* Header */}
      <Header data-component-id="src/app/contact-us/ContactPage.tsx:41:6" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="41" data-component-file="ContactPage.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />

      {/* Main Content */}
      <main data-component-id="src/app/contact-us/ContactPage.tsx:44:6" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="44" data-component-file="ContactPage.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22w-full%20flex-grow%22%7D" className="w-full flex-grow">
        <section data-component-id="src/app/contact-us/ContactPage.tsx:45:8" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="45" data-component-file="ContactPage.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20relative%22%7D" className="w-full relative">
          {/* Background Image */}
          <div data-component-id="src/app/contact-us/ContactPage.tsx:47:10" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="47" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20-z-10%22%7D" className="absolute inset-0 -z-10">
            <Image data-component-id="src/app/contact-us/ContactPage.tsx:48:12" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="48" data-component-file="ContactPage.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Fimg-gradient-background.webp%22%2C%22alt%22%3A%22img-gradient-background%22%2C%22className%22%3A%22object-cover%22%7D"
              src="/images/img-gradient-background.webp"
              alt="img-gradient-background"
              height={500}
              width={500}
              className="object-cover"
              priority
              unoptimized
            />
          </div>

          {/* Content Wrapper */}
          <div data-component-id="src/app/contact-us/ContactPage.tsx:60:10" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="60" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-4xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-16%20flex%20flex-col%20items-center%22%7D" className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col items-center">
            {/* Centered Heading */}
            <h1 data-component-id="src/app/contact-us/ContactPage.tsx:62:12" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="62" data-component-file="ContactPage.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-white%20capitalize%20text-3xl%20sm%3Atext-5xl%20font-semibold%20mb-1%20text-center%20mb-10%20mt-%5B100px%5D%22%2C%22textContent%22%3A%22Get%20in%20touch%22%7D" className="text-white capitalize text-3xl sm:text-5xl font-semibold mb-1 text-center mb-10 mt-[100px]">
              Get in touch
            </h1>

            {/* Form Container */}
            <div data-component-id="src/app/contact-us/ContactPage.tsx:67:12" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="67" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-white%20border%20border-%5Blinear-gradient(0deg%2C%2320293200_0%25%2C%23282acb_100%25)%5D%20rounded-lg%20p-4%20%22%7D" className="w-full bg-white border border-[linear-gradient(0deg,#20293200_0%,#282acb_100%)] rounded-lg p-4 ">
              {/* Optional: Remove this heading if HubSpot form includes one */}
              <h2 data-component-id="src/app/contact-us/ContactPage.tsx:69:14" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="69" data-component-file="ContactPage.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-black%20text-xl%20font-dm%20font-medium%20mb-7%20text-left%22%2C%22textContent%22%3A%22Contact%20Us%22%7D" className="text-black text-xl font-dm font-medium mb-7 text-left">
                Contact Us
              </h2>

              {/* HubSpot Form */}
              <div data-component-id="src/app/contact-us/ContactPage.tsx:74:14" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="74" data-component-file="ContactPage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22hubspotForm%22%7D" id="hubspotForm" />
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer data-component-id="src/app/contact-us/ContactPage.tsx:81:6" data-component-path="src/app/contact-us/ContactPage.tsx" data-component-line="81" data-component-file="ContactPage.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />
    </div>
  );
}
